export default __webpack_public_path__ + "static/media/wooden-slob.7d6df539.svg";